import axios from 'axios';

function isObject(object) {
	return object != null && typeof object === 'object';
}

function isEqual(obj1, obj2) {
	var props1 = Object.getOwnPropertyNames(obj1);
	var props2 = Object.getOwnPropertyNames(obj2);
	if (props1.length !== props2.length) {
		return false;
	}
	for (var i = 0; i < props1.length; i++) {
		let val1 = obj1[props1[i]];
		let val2 = obj2[props1[i]];
		let isObjects = isObject(val1) && isObject(val2);
		if (isObjects && !isEqual(val1, val2) || !isObjects && val1 !== val2) {
			return false;
		}
	}
	return true;
}


export default class {
	constructor(form) {
		this.errorMessage = form.querySelector('.postcodecheck-error-message');
		this.postcode = form.querySelector('.postcodecheck-postcode input');
		this.housenumber = form.querySelector('.postcodecheck-housenumber input');
		this.housenumberEx = form.querySelector('.postcodecheck-housenumber-ex input');
		this.street = form.querySelector('.postcodecheck-street input');
		this.city = form.querySelector('.postcodecheck-city input');

		if (!(this.postcode && this.housenumber)) {
			return;
		}

		this.errorMessage.hidden = true;

		this.prevState = {};

		form.addEventListener('change', (evt) => {
			const state = {
				postcode: this.postcode.value,
				housenumber: this.housenumber.value,
				housenumberEx: this.housenumberEx.value,
			};

			if (!state.postcode || !state.housenumber) {
				return;
			}

			if (!isEqual(state, this.prevState)) {
				if (this.street) {
					this.street.disabled = true;
				}

				if (this.city) {
					this.city.disabled = true;
				}

				this.check(state.postcode, state.housenumber, state.housenumberEx).then((result) => {
					[this.postcode, this.housenumber, this.housenumberEx].map((elm) => {
						elm.closest('.gfield').classList.toggle('postcodecheck-error', !result.street);

						result.street ? (this.errorMessage.hidden = true) : (this.errorMessage.hidden = false);
					});

					if (this.street && result.street) {
						this.street.disabled = false;
						if (!this.street.value) {
							this.street.value = result.street;
						}
					}

					if (this.city && result.city) {
						this.city.disabled = false;
						if (!this.city.value) {
							this.city.value = result.city;
						}
					}
				});

				this.prevState = state;
			}
		});
	}

	async check(postcode, housenumber, housenumberEx){
		const res = await axios.get("/wp/wp-admin/admin-ajax.php", {
			params: {
				action: "lookup_postcode",
				postcode: postcode,
				number: housenumber + housenumberEx
			},
		});

		return res.data;
	}
}
